export const GET_RANKING_SUMMARY = '/ranking/summary'
